var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6841_27714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.69482 8.05361C8.69482 8.05361 9.00764 6.37954 11.0002 6.38871C12.9928 6.39788 13.6666 8.84309 12.6159 9.91215C12.1461 10.3923 11.7439 10.7876 11.4586 11.0649C11.3134 11.2084 11.1981 11.3794 11.1194 11.5678C11.0407 11.7562 11.0002 11.9584 11.0002 12.1626V13.0483",
    stroke: "#08081B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9999 2.73156C6.43342 2.73156 2.73156 6.43342 2.73156 10.9999C2.73156 15.5664 6.43342 19.2682 10.9999 19.2682C15.5664 19.2682 19.2682 15.5664 19.2682 10.9999C19.2682 6.43342 15.5664 2.73156 10.9999 2.73156ZM1.85156 10.9999C1.85156 5.94741 5.94741 1.85156 10.9999 1.85156C16.0524 1.85156 20.1482 5.94741 20.1482 10.9999C20.1482 16.0524 16.0524 20.1482 10.9999 20.1482C5.94741 20.1482 1.85156 16.0524 1.85156 10.9999Z",
    fill: "#08081B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0002 15.7941C11.1167 15.7941 11.2111 15.6997 11.2111 15.5832C11.2111 15.4668 11.1167 15.3724 11.0002 15.3724C10.8838 15.3724 10.7894 15.4668 10.7894 15.5832C10.7894 15.6997 10.8838 15.7941 11.0002 15.7941ZM10.3311 15.5832C10.3311 15.2137 10.6307 14.9141 11.0002 14.9141C11.3698 14.9141 11.6694 15.2137 11.6694 15.5832C11.6694 15.9528 11.3698 16.2524 11.0002 16.2524C10.6307 16.2524 10.3311 15.9528 10.3311 15.5832Z",
    fill: "#08081B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9999 15.9093C11.1796 15.9093 11.3253 15.7636 11.3253 15.5839C11.3253 15.4042 11.1796 15.2585 10.9999 15.2585C10.8202 15.2585 10.6745 15.4042 10.6745 15.5839C10.6745 15.7636 10.8202 15.9093 10.9999 15.9093ZM10.4453 15.5839C10.4453 15.2776 10.6936 15.0293 10.9999 15.0293C11.3062 15.0293 11.5545 15.2776 11.5545 15.5839C11.5545 15.8902 11.3062 16.1385 10.9999 16.1385C10.6936 16.1385 10.4453 15.8902 10.4453 15.5839Z",
    fill: "#08081B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 16.2715C11.3797 16.2715 11.6875 15.9637 11.6875 15.584C11.6875 15.2043 11.3797 14.8965 11 14.8965C10.6203 14.8965 10.3125 15.2043 10.3125 15.584C10.3125 15.9637 10.6203 16.2715 11 16.2715Z",
    fill: "#08081B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6841_27714"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/Help.fef833158c2b4cfb5af8c6e104937f1b.svg";
export { ForwardRef as ReactComponent };